import { statusBadgeUi } from '@/components/Common/StatusBadge/StatusBadgeUi';
import { ColumnHeaderUi, PagingUi } from '@/components/TableData/TableDataUi';

export type ProductByVendorItemUi = {
  masterId: string;
  vendorId: string;
  vendorName: string;
  productName: string;
  packagingType: string;
  lastUpdate: string;
  price: string;
  status?: statusBadgeUi;
};

export type ProductsByVendorUi = {
  columnHeaders: ColumnHeaderUi[];
  items: ProductByVendorItemUi[];
  searchQuery: string;
  isSearching?: boolean;
  paging?: PagingUi;
  isLoading?: boolean;
};

const tableHeaders = [
  { label: 'ID Master' },
  { label: 'ID Vendedor' },
  { label: 'Vendedor' },
  { label: 'Nombre' },
  { label: 'Presentación' },
  { label: 'Actualización' },
  { label: 'Precio' },
  { label: 'Estatus' },
  { label: '' },
];

export const initialState: ProductsByVendorUi = {
  columnHeaders: tableHeaders,
  items: [],
  searchQuery: '',
};
